<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px !important; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;" class="list-page-main-header">
              <span><fa-icon [icon]="['fas', 'books']"> </fa-icon> Training Records </span>
            </h3>
          </div>
        </div>
        <div class="col pull-right">
          <app-eca-ghost-btn class="card-action-icon float-right"
                             btnIcon="question-circle" btnType="warning"
                             (btnClicked)="openTrainingRecordsHelp()"></app-eca-ghost-btn>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="body" class="eca-card-body">
      <div class="container-fluid" style="margin-bottom: 50px; padding-right: 0; padding-left: 0;">
        <div *ngIf="trainingRecordsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!trainingRecordsLoading">
          <app-company-operative-training-records [showHeaderText]="true"
                                                  [trainingRecords]="trainingRecords"
                                                  (refreshListRequested)="loadTrainingRecordSummaries()"
                                                  [allowedOperations]="loggedInUser?.trainingRecordOperations"
                                                  [companyId]="companyId">
          </app-company-operative-training-records>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
